import { func, oneOf, string } from 'prop-types';
import { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { addAsset } from 'actions/assets';

// A simple component that dispatches an addAsset action. This is used to
// request lazy loading of a JS or CSS asset by LazyAssetRenderer.
export class LazyAsset extends Component {
  componentDidMount() {
    const { type, uri } = this.props;
    this.props.addAsset(type, uri);
  }
  render() {
    return null;
  }
}

LazyAsset.propTypes = {
  type: oneOf(['js', 'css']).isRequired,
  uri: string.isRequired,
  addAsset: func.isRequired
};

export default connect(
  null,
  dispatch => bindActionCreators({ addAsset }, dispatch)
)(LazyAsset);
